// Substitutions list for the match form. Rolling subs: any number of
// on/off events. Touch-friendly inputs (44pt+ height).

interface DraftSub {
  minute: string;
  direction: 'on' | 'off';
}

interface Props {
  subs: DraftSub[];
  onChange: (next: DraftSub[]) => void;
  errors?: Record<string, string>;
}

export function SubsList({ subs, onChange, errors }: Props) {
  const update = (idx: number, patch: Partial<DraftSub>) => {
    onChange(subs.map((s, i) => (i === idx ? { ...s, ...patch } : s)));
  };
  const remove = (idx: number) => onChange(subs.filter((_, i) => i !== idx));
  const add = (direction: 'on' | 'off') => onChange([...subs, { minute: '', direction }]);

  return (
    <div>
      {subs.length === 0 ? (
        <p style={{ color: 'var(--muted)', fontSize: 13, margin: '0 0 8px' }}>
          Grassroots rolling subs. Add on/off events as they happen, in any order.
        </p>
      ) : null}

      {subs.map((s, idx) => {
        const err = errors?.[`sub_${idx}`];
        return (
          <div key={idx} style={{
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            padding: 8,
            background: 'var(--surface)',
            border: `1px solid ${err ? 'var(--error)' : 'var(--border)'}`,
            borderRadius: 10,
            marginBottom: 8,
          }}>
            <button
              type="button"
              onClick={() => update(idx, { direction: s.direction === 'on' ? 'off' : 'on' })}
              style={{
                minWidth: 64,
                minHeight: 44,
                padding: '0 14px',
                borderRadius: 999,
                border: `1px solid ${s.direction === 'on' ? '#1F3D2C' : 'var(--border)'}`,
                background: s.direction === 'on' ? 'var(--green)' : 'transparent',
                color: s.direction === 'on' ? 'var(--ink-on-green)' : 'var(--ink)',
                fontFamily: 'inherit',
                fontSize: 14,
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              {s.direction === 'on' ? 'On ▲' : 'Off ▼'}
            </button>
            <input
              type="number"
              inputMode="numeric"
              min={0}
              placeholder="Minute"
              value={s.minute}
              onChange={(e) => update(idx, { minute: e.target.value })}
              style={{
                flex: 1,
                minHeight: 44,
                padding: '8px 12px',
                borderRadius: 10,
                border: '1px solid var(--border)',
                background: 'var(--bg)',
                fontSize: 16,
                color: 'var(--ink)',
                fontFamily: 'inherit',
              }}
            />
            <button
              type="button"
              onClick={() => remove(idx)}
              aria-label="Remove sub"
              style={{
                width: 44,
                height: 44,
                background: 'transparent',
                border: 'none',
                color: 'var(--error)',
                fontSize: 20,
                cursor: 'pointer',
              }}
            >
              ✕
            </button>
          </div>
        );
      })}

      <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
        <button
          type="button"
          onClick={() => add('on')}
          style={chipBtn(true)}
        >
          + Sub on
        </button>
        <button
          type="button"
          onClick={() => add('off')}
          style={chipBtn(false)}
        >
          + Sub off
        </button>
      </div>
    </div>
  );
}

function chipBtn(_primary: boolean): React.CSSProperties {
  return {
    minHeight: 44,
    padding: '10px 16px',
    borderRadius: 999,
    border: '1px solid var(--border)',
    background: 'transparent',
    color: 'var(--green)',
    fontFamily: 'inherit',
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
  };
}
